module.exports = __webpack_public_path__ + "img/ax.a127e07.svg";